import React from "react";

import {p0, p1, p2, p4, p8, p16, p32} from "../../pl_commons";
import PlIcon from "../pl_icon";
import {is_bus_available} from "./plan_commons";
import {uidEqual} from "../../../../bidib/bidib_commons";

const FbIcon = ({item, bidib}) => {

    const a = bidib.find(it => uidEqual(it.uid, item.fbaddr) )
    const avail = a && a.available || false

    const strokecolor = avail?'#000000':'#7c7c7c'

    let bmstate = item.fbstat === "true"
    let bmlcid = item.bmlc > 0 ? item.bmlc : ""

    var svgitems = [];
    var rtcolor = '#777777';

    let inroute = item.lockdir === "east" || item.lockdir === "west"

    if (inroute) {
        rtcolor = '#fff44f';
    } else if (item.inmemory === "true") {
        rtcolor = '#74bbff';
    }
    if (bmstate) {
        rtcolor = '#ff0000';
// Bessere Sichtbarkeit ...
        /*svgitems.push(<circle
                cx={p2}
                cy={p2}
                r={p2}
                fill={'#DD0000'}/>);*/

    }

    if( !avail) {
        rtcolor = '#7c7c7c'
    }


    if( item.fbaddr !== "NA" && item.fbstat === undefined) {
        rtcolor = '#d568b4'
    }

    let lcidstorecolor = '#000000';
    let fontw = 'normal';

    if (item.lcidstore === 'true') {
        if (item.calclcid && item.calclcid !== "...") {
            fontw = 'bold';
            bmlcid = item.calclcid + '*';
        }
        svgitems.push(<line key="l2x" x1={p4} y1={p2 - p8 - p8} x2={p1 - p4} y2={p2 - p8 - p8} strokeWidth={p32}
                            stroke={lcidstorecolor}
                            strokeLinecap="butt"/>);
    }

    if (item.trustbidib === 'true') {
        svgitems.push(<line key="l3x" x1={p4} y1={p2 - p8 - p8} x2={p4} y2={p2 - p8} strokeWidth={p32}
                            stroke={lcidstorecolor}
                            strokeLinecap="butt"/>);
        svgitems.push(<line key="l4x" x1={p1 - p4} y1={p2 - p8 - p8} x2={p1 - p4} y2={p2 - p8} strokeWidth={p32}
                            stroke={lcidstorecolor}
                            strokeLinecap="butt"/>);
    }

    //let pp = (bmlcid && bmlcid.length < 4) ? p4 : p16;
    svgitems.push(<text key="t1" x={p0 + p4} y={p2 + p4 + p8} fontSize="8px" fontWeight={fontw}>{bmlcid}</text>);

    svgitems.push(<line key="l1" x1={p4} y1={p2 - p8} x2={p1 - p4} y2={p2 - p8} strokeWidth={p32} stroke={strokecolor}
                        strokeLinecap="butt"/>);

    svgitems.push(<line key="l2" x1={p0} y1={p2} x2={p1} y2={p2} strokeWidth={p8} stroke={strokecolor}
                        strokeLinecap="butt"/>);
    svgitems.push(<line key="l12" x1={p16} y1={p2} x2={p2 - p16} y2={p2} strokeWidth={p16} stroke={rtcolor}
                        strokeLinecap="butt"/>);
    svgitems.push(<line key="l13" x1={p2 + p16} y1={p2} x2={p1 - p16} y2={p2} strokeWidth={p16} stroke={rtcolor}
                        strokeLinecap="butt"/>);


    return(
        <PlIcon item={item} transform={undefined}>
            {svgitems}
        </PlIcon>
    )
}

export default FbIcon